<template>
  <component :is="tag" :class="classes" v-bind="$attrs" @click="$emit('click', $event)">
    <slot>{{ label }}</slot>
  </component>
</template>

<script>
  export default {
    name: 'InputButton',
    props: {
      label: {
        type: String,
        default: ''
      },
      type: {
        type: String,
        default: 'primary',
        validator: (value) => {
          return ['primary', 'common'].includes(value) !== -1
        },
      },
      size: {
        type: String,
        default: 'medium',
        validator: (value) => {
          return ['big' ,'large', 'medium', 'small'].includes(value) !== -1
        },
      },
      isLoading: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      tag() {
        return this.$attrs.href ? 'a' : 'button'
      },
      classes() {
        const classes = [ 'button', `--${this.type}`, `--${this.size}` ]
        if(this.isLoading) classes.push('is-loading')
        return classes
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/_variables.scss';

  .button {
    display: block;
    text-align: center;
    font-weight: 800;
    text-decoration: none;
    position: relative;
    cursor: pointer;
    border: none;
    width: 100%;
    transition: $transition-common;
    &.--big {
      height: 72px;
      font-size: 2.2rem;
      border-radius: 34px;
    }
    &.--large {
      height: 46px;
      line-height: 46px;
      font-size: 1.7rem;
      border-radius: 23px;
      font-weight: 600;
    }
    &.--medium {
      height: 32px;
      line-height: 32px;
      font-size: 1.3rem;
      border-radius: 16px;
    }
    &.--small {
      height: 32px;
      line-height: 32px;
      font-size: 1.3rem;
      border-radius: 16px;
    }

    @include media(pc) {
      padding: 0 24px;
    }
    @include media(sp) {
      padding: 0 16px;
    }


    &.--primary {
      background: $gradation-vertical;
      color: $color-font-inverse;
    }
    &.--common {
      background: $color-secondary;
      color: $color-font-inverse;
    }
    &:disabled {
      background: $color-disabled;
      cursor: not-allowed;
    }
    &.is-loading {
      background: $color-secondary;
      cursor: not-allowed;

      @include media(pc) {
        padding-right: 48px;
      }
      @include media(sp) {
        padding-right: 40px;
      }

      &::after {
        position: absolute;
        top: 12px;
        right: 12px;
        content: "";
        width: 24px;
        height: 24px;
        display: inline-block;
        vertical-align: middle;
        background: url(/assets/sf/icon/loading.svg);
        background-size: contain;
        animation: 1500ms linear infinite rotation;
      }
    }
    &:not(:disabled):hover {
      opacity: $opacity-hover;
    }
  }
  @keyframes rotation{
    0%{ transform:rotate(0);}
    100%{ transform:rotate(360deg); }
  }
</style>